export default __webpack_public_path__ + "static/media/breast-cancer.be37d4a8.jpg";